module.exports = {"header":"ติดต่อ","address":{"header":"โครงการ วมว.สำนักงานห้องเรียนวิศว์-วิทย์","detail":"<strong>สถาบันพัฒนาและฝึกอบรมโรงงานต้นแบบ (สรบ.)</strong><br>มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี บางขุนเทียน เลขที่ 49 ซอยเทียนทะเล 25 ถนนบางขุน-เทียนชายทะเล แขวงท่าข้าม เขตบางขุนเทียน กรุงเทพมหานคร 10150"},"map":"images/Home/school_map.jpg","mapNotice":"คลิ๊กที่รูปเพื่อเปิดแผนที่"}


//////////////////
// WEBPACK FOOTER
// ./src/json/th/home/contact.json
// module id = su+Y
// module chunks = 41